// extracted by mini-css-extract-plugin
module.exports =  {"header":"VJTepHWEc74vIhO0U5rK","tab":"L_Eg5C79o0w3lmSFnlDf"};